import { Link } from 'react-router-dom';
import { rankingComics } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-3">
            <div>
              <span className="text-xs text-foreground-400 tracking-wider uppercase">人气榜单</span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
                韩漫排行榜
              </h2>
            </div>
            <div className="flex items-center gap-2">
              <button className="bg-primary-500 text-background-50 text-xs font-medium px-4 py-2 rounded-full whitespace-nowrap cursor-pointer">
                人气榜
              </button>
              <button className="bg-background-200/70 text-foreground-600 text-xs font-medium px-4 py-2 rounded-full whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors">
                新作榜
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
            {rankingComics.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className={`group relative rounded-lg overflow-hidden cursor-pointer bg-background-50 hover:bg-background-200/50 transition-colors ${
                  idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
                }`}
              >
                {idx === 0 ? (
                  <div className="flex flex-col lg:flex-row h-full">
                    <div className="relative w-full lg:w-1/2 aspect-[5/7] lg:aspect-auto overflow-hidden">
                      <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 p-6 flex flex-col justify-center gap-3">
                      <span className="text-accent-500 text-xs font-bold tracking-wider">TOP 1</span>
                      <h3 className="font-heading text-xl font-bold text-foreground-900">{comic.title}</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{comic.description}</p>
                      <div className="flex items-center gap-3 text-xs text-foreground-400">
                        <span>{comic.author}</span>
                        <span>·</span>
                        <span>{comic.category}</span>
                        <span>·</span>
                        <span className="text-accent-500">{(comic.views / 10000).toFixed(0)}万阅读</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center gap-4 p-4">
                    <span className={`text-2xl font-heading font-bold flex-shrink-0 w-8 text-center ${
                      idx === 1 ? 'text-accent-500' : idx === 2 ? 'text-secondary-500' : 'text-foreground-300'
                    }`}>
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                    <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                      <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                        {comic.title}
                      </h3>
                      <div className="flex items-center gap-2 text-xs text-foreground-400 mt-0.5">
                        <span className="flex items-center gap-0.5">
                          <span className="w-3 h-3 flex items-center justify-center">
                            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                          </span>
                          {comic.rating}
                        </span>
                        <span>{(comic.views / 10000).toFixed(0)}万阅读</span>
                      </div>
                    </div>
                  </div>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}